import ContractBaseController from '../common/contract.base.controller'
import AppConstants from '../../../../../config/app.constants';

class ContractEditController extends ContractBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, ContractService, Modal, $translate, $stateParams, $q, $filter, BillableEventsService,
		CommonLayoutService, LocationDistanceService, ContractTypeService, DateUtil, $scope) {

		super(Auth, $state, User, ContractService, Modal, $translate, $stateParams)

		this.mainFormChanged = false;
		this.$q = $q;
		this.$filter = $filter;
		this.isExporting = false;
		this.BillableEventsService = BillableEventsService;
		this.CommonLayoutService = CommonLayoutService;
		this.LocationDistanceService = LocationDistanceService;
		this.ContractTypeService = ContractTypeService;
		this.DateUtil = DateUtil;
		this.$scope = $scope;
		this.contractLogs = [];
		this.page = 1;
		this.total = 0;
		this.pageLimit = 10;
		this.maxPages = 10
		this.searchText = '';
		this.logsOf = '';
		this.customers = [];
		this.contractRulesLocationSearchText = '';
		this.showAllFlag = false;
		this.defaultModel = {
			contractId: '',
			contractName: '',
			status: true,
			selectedBillingDuration: '',
			description: '',
			contractStartDate: null,
			contractEndDate: null,
			useCustomerOnBillingRules: false,
			locationList: [],
			deletedContractRules: [],
			bailmentInterest: null,
			contractTypeId: '',
			dateRange: {
				startDate: '',
				endDate: ''
			},
		};
		this.model = angular.copy(this.defaultModel);
		this.formValues = {}
		this.billingIncrementList = [
			{ label: this.$translate.instant('contract.daily'), value: 'DAILY' },
			{ label: this.$translate.instant('contract.weekly'), value: 'WEEKLY' },
			{ label: this.$translate.instant('contract.bi_weekly'), value: 'BI_WEEKLY' },
			{ label: this.$translate.instant('contract.monthly'), value: 'MONTHLY' },
			{ label: this.$translate.instant('contract.quarterly'), value: 'QUARTERLY' },
			{ label: this.$translate.instant('contract.annually'), value: 'ANNUALLY' }
		];
		this.selectedTab = 'rules';
		this.filterByValue = "active";
		this.branchId = this.User.getUser().branchId;
		this.loading = true;
		this.contractRulesLocationLoading = false;
		this.contractRules = [];
		this.billingRulesOptions = [];
		this.entryTypes = [];
		this.contractRulesRecordStats = {
			active: 0,
			inactive: 0
		}
		this.showBillingWarning = false;
		this.locationTypeOptions = {
			'ATM': [{
				label: 'ATM',
				value: 'atm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Regular',
				value: 'regular'
			},
			{
				label: 'NSNG',
				value: 'nsng'
			},
			{
				label: 'On Call',
				value: 'on_call'
			},
			{
				label: 'Bank',
				value: 'bank'
			}]
		};

		this.serviceTypeOptions = {
			'regular': [{
				label: 'Scheduled',
				value: 'regular'
			}],
			'flm': [{
				label: 'FLM',
				value: 'flm'
			}],
			'slm': [{
				label: 'SLM',
				value: 'slm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
			{
				label: 'Scheduled',
				value: 'regular'
			}
			],
			'atmLoad': [{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
			{
				label: 'Scheduled',
				value: 'regular'
			},
			{
				label: 'Emergency',
				value: 'emergency'
			}],
			'none': [{
				label: 'none',
				value: 'none'
			}],
		};

		this.scheduleTypeOptions = [
			{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Scheduled',
				value: 'scheduled'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
		];

		this.orderTypeOptions = {
			'cash_coin': [{
				label: 'Cash & Coin',
				value: 'cash_and_coin'
			}],
			'cash_only': [{
				label: 'Cash',
				value: 'cash'
			}],
			'coin_only': [{
				label: 'Coin',
				value: 'coin'
			}],
			'ATM': [{
				label: 'ATM-Any',
				value: 'atm_any'
			},
			{
				label: 'ATM-Add',
				value: 'atm_add'
			},
			{
				label: 'ATM-Swap',
				value: 'atm_swap'
			},
			{
				label: 'ATM-ICL',
				value: 'atm_icl'
			},
			{
				label: 'ATM-CCL',
				value: 'atm_ccl'
			},
			{
				label: 'ATM-Recash',
				value: 'atm_recash'
			},
			{
				label: 'ATM-Decash',
				value: 'atm_decash'
			}],
			'services': [{
				label: 'Service Order',
				value: 'service_order'
			}],
			'other': [{
				label: 'none',
				value: 'none'
			}],
		};

		this.billingTypeOptions = this.CommonLayoutService.billingTypeOptions();
		this.serviceTimeOptions = this.CommonLayoutService.serviceTimeTypes();
		this.serviceTimeTypes = this.CommonLayoutService.serviceTimeTypes();

		this.stats = {
			pre: 'PRE',
			post: 'POST'
		};

		this.existingBillingRules = {};
		this.disableOtherOptions = {};
		this.isDisableServiceTypeOptions = {};
		this.disableScheduleTypeOptions = {};
		this.allowScheduleTypeBillingEvents = ['atm-deposit-count', 'delivery-order-pack', 'service-ticket-cancelled', 'service-ticket-incomplete',
			'atm-residual-deposit', 'atm-order-pack', 'atm-residual-count', 'part-charge', 'service-ticket-completed', 'residual-deposit', 'pickup-deposit',
			'order-packing-pack', 'atm-service'];
		this.requiredStartDate = false;
		this.requiredStartDateErrorMsg = 'As this contract does not have a start date, it will not generate pre/post bill records if any pre/post bill rules are defined.';

		this.contractLocationListObj = {
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 200,
				maxPages: 10
			},
		}

		this.locationObj = {
			results: [],
			totalLocations: 0,
			pageLimit: 200
		}

		this.associateLocationObj = {
			results: [],
			totalLocations: 0,
			pageLimit: 200
		}

		this.customerObj = {
			loading: false,
			totalRecords: 0,
			results: [],
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 10,
				maxPages: 10
			},
		}

		this.contractRulesStatus = {
			active: true,
			suspended: false
		}

		this.contractTypeObj = {
			loading: false,
			totalRecords: 0,
			results: [],
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 10,
				maxPages: 10
			},
		}

		this.staticBillingEvents = ['pre-bill', 'post-bill'];
	}

	setDateRange(date) {
		this.loading = true;
		let currentVaultDate = date || moment();
		this.model.dateRangPickerOptions = {
			autoApply: true,
			eventHandlers: {
				'apply.daterangepicker': () => {
					this.page = 1;
					this.loadData(this.model.dateRange);
				}
			},
			ranges: {
				'Today': [
					moment().format('YYYY-MM-DD'),
					moment().format('YYYY-MM-DD')
				],
				'Current Week': [
					moment().startOf('week').format('YYYY-MM-DD'),
					moment().endOf('week').format('YYYY-MM-DD')
				],
				'Current Month': [
					moment().startOf('month').format('YYYY-MM-DD'),
					moment().endOf('month').format('YYYY-MM-DD')
				]
			}
		}
	}

	$onInit() {
		this.loading = true;
		this.$q.all([
			this.Service.get(this.$stateParams.id),
		])
			.then((data) => {
				this.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
				this.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
				const contractData = data[0];
				this.rawId = contractData.id;
				this.defaultModel = {
					...contractData,
					dateRange: {
						startDate: '',
						endDate: ''
					}
				};
				this.model.contractId = contractData.id;
				this.model.contractName = contractData.contractName;
				this.model.status = contractData.status;
				this.model.description = contractData.description;
				this.model.selectedBillingDuration = contractData.billingIncrement;
				this.contractRules = contractData.contractRulesData;
				this.generalLedgerCode = contractData.generalLedgerCode;
				this.model.contractStartDate = contractData.contractStartDate ? this.DateUtil.convertToDate(contractData.contractStartDate) : null;
				this.model.contractEndDate = contractData.contractEndDate ? this.DateUtil.convertToDate(contractData.contractEndDate) : null;
				this.model.useCustomerOnBillingRules = contractData.useCustomerOnBillingRules;
				this.model.bailmentInterest = contractData.bailmentInterest ? contractData.bailmentInterest + '%' : null;
				this.model.contractTypeId = contractData.contractType,
					this.formValues = angular.copy(this.model);
				this.startMinDate = {
					minDate: this.model.contractStartDate
				}
				this.filePrefix = `${'ContractRuleHistory_' + this.model.contractName}`;
				this.startMaxDate = {
					minDate: new Date()
				}
				this.ruleStartDateOptions ={
					minDate: moment(this.model.contractStartDate),
					...(this.model.contractEndDate && { maxDate: moment(this.model.contractEndDate) })
				};
	  			this.updateContractStats(contractData.contractRulesData);

				if (contractData.contractRulesData.length) {
					contractData.contractRulesData.forEach((cr, index) => {
						if (this.staticBillingEvents.includes(cr.billingEvent)) {
							this.model.disableBillingIncrement = true;
							cr.billingTime = cr.billingEvent === 'pre-bill' ? this.stats.pre : this.stats.post;
							cr.scheduleType = null;
							this.disableOtherOptions[index] = {
								disabled: true
							}
							this.requiredStartDate = true;
						}
						else {
							cr.billingTime = this.stats.post;
							this.disableOtherOptions[index] = {
								disabled: false
							}
							this.requiredStartDate = false;
						}
						if (this.allowScheduleTypeBillingEvents.includes(cr.billingEvent)) {
							this.disableScheduleTypeOptions[index] = {
								disabled: true
							}
							cr.scheduleType = null;
						}
						else {
							this.disableScheduleTypeOptions[index] = {
								disabled: false
							}
						}
					})
				}
				this.startDateErrorMessage = this.requiredStartDateErrorMsg;
				this.currentVaultDate = this.DateUtil.convertToDate(this.DateUtil.convertToDate(contractData.contractStartDate));
				this.vaultDate = moment().format('YYYY-MM-DD');
				this.setDateRange(this.vaultDate);
				// this.loadData();
			})
			.then(() => {
				this.getBillableEvents();
				this.locationDistanceList();
				this.getContractLocationList();
				this.getCustomerLocationList();
				this.getCustomerList('', 0);
				this.getContractTypeList('', 0);
			})
			.catch((err) => {
				this.error = err.message;
			})
			.finally(() => {
				this.loading = false;
			})
	}


	loadData() {
		this.loading = true;
		const searchObj = this.generateSearchObj();
		this.contractLogs = [];

		this.Service.getContractLogs(this.$stateParams.id, searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
			.then(data => {
				this.contractLogs = data.results.map(log => {
					log.readableEntryType = this.$translate.instant('entry_type.' + log.entryType);
					if (log.entryData) {
						log.extraDetails = Object.entries(log.entryData).map(([key, value]) => ({
							key,
							value: typeof value === 'object' ? JSON.stringify(value) : value
						}));
					}
					return log;
				});

				this.total = data.total;

				if (data.allEntryTypes.length > 0 && !this.entryType) {
					this.entryTypes = data.allEntryTypes.map(entryType => ({
						label: this.$translate.instant('entry_type.' + entryType),
						value: entryType
					}));
				}
			})
			.catch(error => {
				console.error('Error loading contract logs:', error);
				// Handle error appropriately (e.g., show user-friendly message)
			})
			.finally(() => {
				this.loading = false;
			});
	}

	search() {
		this.page = 1;
		this.loading = true;
		this.loadData();
	}

	refresh() {
		this.loading = true;
		this.loadData();
	}

	pageChange() {
		this.loading = true;
		this.loadData()
	}

	generateSearchObj() {
		return {
			logsOf: this.logsOf,
			entryType: this.entryType,
			queryText: this.searchText,
			isQuery: false,
			startDate: moment(this.model.dateRange.startDate).startOf('day').format('YYYY-MM-DD 00:00:00'),
			endDate: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
		}
	}

	getContractDetails() {
		this.model.contractRules = [];
		this.contractRules = [];

		this.Service.get(this.$stateParams.id)
			.then((data) => {
				const contractData = data;
				this.contractRules = contractData.contractRulesData;
				this.model.contractRules = contractData.contractRulesData;
				this.model.contractStartDate = contractData.contractStartDate ? this.DateUtil.convertToDate(contractData.contractStartDate) : null;
				this.model.contractEndDate = contractData.contractEndDate ? this.DateUtil.convertToDate(contractData.contractEndDate) : null;
				this.updateContractStats(contractData.contractRulesData);
			})
			.then(() => { })
			.catch((err) => {
				this.error = err.message;
			})
			.finally(() => {
				this.loading = false;
			})
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.model.contractId = this.defaultModel.id;
		this.model.selectedBillingDuration = this.defaultModel.billingIncrement;
		this.model.contractStartDate = this.defaultModel.contractStartDate ? this.DateUtil.convertToDate(this.defaultModel.contractStartDate) : null;
		this.model.contractEndDate = this.defaultModel.contractEndDate ? this.DateUtil.convertToDate(this.defaultModel.contractEndDate) : null;
		this.formValues = angular.copy(this.model);
		this.model.bailmentInterest = this.defaultModel.bailmentInterest ? this.defaultModel.bailmentInterest + '%' : null;
		this.model.contractTypeId = this.defaultModel.contractType;
		this.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
		this.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
		// this.billingRulesOptions = [];
		// this.clearErrors();
		// this.getBillableEvents();

		if (this.formValues.contractRulesData && this.formValues.contractRulesData.length > 0) {
			this.billingRulesOptions.forEach((rule, index) => {
				if (this.formValues.contractRulesData[index]) {
					rule.contractRulesLocations = this.formValues.contractRulesData[index].locationApplicable;
					setTimeout(()=>{
						rule.locationDistanceId = this.formValues.contractRulesData[index].locationDistanceId;
						rule.locationDistance = this.formValues.contractRulesData[index].locationDistance ? this.formValues.contractRulesData[index].locationDistance: null;
					});
				}
			})
		}
		if (this.contractRulesLocationSearchText) {
			this.contractRulesLocationSearchText = ''
			this.getContractRulesLocation()
		}
		setTimeout(() => {
			this.billingRulesOptions.forEach((obj, index) => {
				this.isAllowScheduleType(obj, index)
			})
		}, 1000)
		this.locationDistanceList();
		this.contractDatesChanged();
	}

	submit(evt) {
		// this.loading = true;

		setTimeout(() => {
			this.model.contractStartDate = this.model.contractStartDate ? moment(this.model.contractStartDate).format('YYYY-MM-DD') : null;
			this.model.contractEndDate = this.model.contractEndDate ? moment(this.model.contractEndDate).format('YYYY-MM-DD') : null;
			this.generateBillingRules('value');
			const contractRules = this.findDifferences(this.contractBillingRules, this.contractRules);
			this.model.billingIncrement = this.model.selectedBillingDuration;
			this.model.contractRules = contractRules;
			this.model.createdByUserId = this.User.getUser().id;
			this.model.modifiedByUserId = this.User.getUser().id;
			this.model.bailmentInterest = this.model.bailmentInterest ? this.convertStr(this.model.bailmentInterest) : null;
			this.model.contractTypeId = this.model.contractTypeId ? this.model.contractTypeId.Value : null;

			this.Service.update(this.rawId, this.model, this.branchId)
				.then((data) => {
					window.history.go(-1);
				})
				.catch((err) => {
					if (err.data.errors) {
						err.data.errors.map((e) => {
							this.errorMessage += e.message + '<br/>'
						})
					}
					else {
						this.errorMessage = err.data.message;
					}
				})
				.finally(() => {
					this.loading = false;
				})
		}, 200);
	}

	isDisabledDate = function (currentDate, mode) {
		if (this.model.contractEndDate !== null) {
			if (this.model.contractStartDate > this.model.contractEndDate) {
				this.model.contractEndDate = this.model.contractStartDate
			}
			else if (this.model.contractStartDate == null) {
				this.model.contractEndDate = null
			}
		}
		this.startMinDate = {
			minDate: this.model.contractStartDate
		}
		this.contractDatesChanged();
	}

	selectBillingIncrement(obj) {
		this.model.selectedBillingDuration = obj.value;

	}

	// billingContractRulesModal(data) {
	// 	this.Modal.billingContractRulesModal(data, true, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
	// 		contractRulesOptions.forEach((rules) => {
	// 			this.contractRules.push(rules);
	// 		})
	// 		modal.close();
	// 	}, ({ modal }) => {
	// 		if (modal) modal.close();
	// 	})
	// }

	// editBillingContract(data, index) {
	// 	this.Modal.billingContractRulesModal(data, true, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
	// 		this.contractRules.splice(index, 1);
	// 		contractRulesOptions.forEach((rules) => {
	// 			this.contractRules.splice(index, 0, rules);
	// 		})
	// 		modal.close();
	// 	}, ({ modal }) => {
	// 		if (modal) modal.close();
	// 	})
	// }

	// isObject(data) {
	// 	return typeof data === 'object'
	// }

	removeBillingContract(billingRuleObj, index) {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('common.confirm_delete_message'),
			callback: (({
				modal,
				$scope
			}) => {
				this.contractRules.splice(index, 1);
				this.billingRulesOptions.splice(index, 1);
				const dataObj = {
					contractName: this.model.contractName, description: billingRuleObj.description,
					contractId: this.model.contractId, contractRuleId: billingRuleObj.contractRulesId,
					contractRulesLocations: billingRuleObj.contractRulesLocations
				}
				setTimeout(() => {
					if (dataObj.contractRuleId === undefined || dataObj.contractRuleId === null) return; 
			                
					this.model.contractStartDate = this.model.contractStartDate ? moment(this.model.contractStartDate).format('YYYY-MM-DD') : null;
					this.model.contractEndDate = this.model.contractEndDate ? moment(this.model.contractEndDate).format('YYYY-MM-DD') : null;
					this.generateBillingRules('value');
					this.model.billingIncrement = this.model.selectedBillingDuration;
					this.model.createdByUserId = this.User.getUser().id;
					this.model.modifiedByUserId = this.User.getUser().id;
					this.loading = true;
					this.Service.deleteContractRule(this.rawId, dataObj, this.branchId)
						.then((data) => {
							this.generateContractBillingRules();
							this.generateBillingRules('value');
							this.getContractDetails();
						}).catch((err) => {
							if (err.data.errors) {
								err.data.errors.map((e) => {
									this.errorMessage += e.message + '<br/>'
								})
							}
							else {
								this.errorMessage = err.data.message;
							}
						})
						.finally(() => {
							this.loading = false;
						})
				}, 200)
				modal.close();
				// if(this.billingRulesOptions.length == 0 ) return this.requiredStartDate = false;
				this.isStartDateIsRequired();
				this.validateStaticBillingOptions();
				this.updateContractStats(this.billingRulesOptions);
			}),
			negative: (({
				modal,
			}) => {
				modal.close();
			}),
			type: 'danger'
		})
	}

	getTime(time, billingType = null) {
		if (!time) {
			return time;
		}

		time = moment(time).format('HH:mm:ss');

		time = time.split(':');

		let d = new Date();

		d.setHours(+time[0]);
		d.setMinutes(time[1]);
		d.setSeconds(time[2]);
		// d.setMilliseconds(0);
		const timeFormat = billingType == 'service_ticket_overage_time_charge' ? 'HH:mm:ss' : '00:mm:ss';
		return moment(d).format(timeFormat);
	}

	// generateContractRules() {
	// 	if (!this.contractRules.length) return [];
	// 	const rules = [];

	// 	this.contractRules.forEach((obj) => {
	// 		if (obj.id) {
	// 			rules.push({
	// 				billingEvent: obj.billingEvent,
	// 				locationType: obj.locationType,
	// 				orderType: obj.orderType,
	// 				billingType: obj.billingType,
	// 				minQty: obj.minQty || null,
	// 				maxQty: obj.maxQty || null,
	// 				minAmount: obj.minAmount || null,
	// 				maxAmount: obj.maxAmount || null,
	// 				beginTime: obj.beginTime,
	// 				endTime: obj.endTime,
	// 				billingRate: obj.billingRate,
	// 				currencyId: obj.currencyId
	// 			})
	// 		}
	// 		else {
	// 			rules.push({
	// 				billingEvent: obj.billingEvent.key,
	// 				locationType: obj.locationType.value,
	// 				orderType: obj.orderType.value,
	// 				billingType: obj.billingTypeObj.billingType.value,
	// 				minQty: obj.billingTypeObj.min || null,
	// 				maxQty: obj.billingTypeObj.max || null,
	// 				minAmount: obj.billingTypeObj.minAmount || null,
	// 				maxAmount: obj.billingTypeObj.maxAmount || null,
	// 				beginTime: obj.billingTypeObj.beginTime ? moment(obj.billingTypeObj.beginTime).format('00:mm:ss') : null,
	// 				endTime: obj.billingTypeObj.endTime ? moment(obj.billingTypeObj.endTime).format('00:mm:ss') : null,
	// 				billingRate: obj.billingRateObj.rate,
	// 				currencyId: obj.billingRateObj.currency
	// 			})
	// 		}
	// 	})
	// 	return rules;
	// }

	translateMessage(prefix, key) {
		if (!key) return;
		else if (key === 'shipment-delivered') return this.$translate.instant('itemHolds.shipment_delivery');
		return this.$translate.instant(prefix.concat(key));
	}

	formatTime(time, billingType = null) {
		if (!time) return;
		return moment(time, ["HH:mm:ss"]).format(billingType === 'SERVICE_TICKET_OVERAGE_TIME_CHARGE' ? 'HH:mm:ss' : '00:mm:ss');
	}

	addBillingRules(event) {
		this.billingRulesOptions.push({
			name: null,
			description: null,
			generalLedgerCode: null,
			status: true,
			isValidBillingRules: false,
			billingEventObj: {
				billingEvent: null,
				billingEventOptions: null,
				preBillingEventOptions: _.cloneDeep(this.preBillingEventOptions),
				postBillingEventOptions: _.cloneDeep(this.postBillingEventOptions)
			},
			locationTypeObj: {
				locationType: null,
				locationTypeOptions: []
			},
			serviceTypeObj: {
				serviceType: null,
				serviceTypeOptions: []
			},
			scheduleTypeObj: {
				scheduleType: null,
				scheduleTypeOptions: this.scheduleTypeOptions
			},
			orderTypeObj: {
				orderType: null,
				orderTypeOptions: []
			},
			billingTypeObj: {
				billingType: null,
				billingTypeOptions: this.billingTypeOptions
			},
			dollarRate: null,
			percentageRate: null,
			dollarRateAbove: null,
			percentageRateAbove: null,
			dollarRateBelow: null,
			percentageRateBelow: null,
			itemThreshold: null,
			valueThreshold: null,
			timeThreshold: null,
			itemIncrement: null,
			valueIncrement: null,
			timeIncrement: null,
			isEdit: true,
			isNew: true,
			applyWrapFee: false,
			wrapFee: null,
			billingTime: 'POST',
			locationDistanceId: null,
			rateFirstHour: null,
			rateFifteenMinutes: null,
			serviceTimeTypeObj: {
				serviceTimeType: []
			},
			contractRulesLocations: [],
			locationList: [],
			sequence: this.billingRulesOptions.length + 1,
			customerList: [],
			billableEventId: null,
			billingCategoryId: null,
			billingCategoryObj: {
				billingCategory: null,
				billingCategoryOptions: _.cloneDeep(this.billingCategoryOptions)
			},
			overageRate: null,
			contractLocationsDistance: [],
			locationOptions: [],
			startDate: this.model.contractStartDate ? moment(this.model.contractStartDate) : new Date(),
			endDate: null
		});
		if(this.model.useCustomerOnBillingRules == true) {
			this.getContractLocationList('', undefined, 1, this.billingRulesOptions.length-1)
		} else {
			this.getCustomerLocationList('', undefined, 1,false, this.billingRulesOptions.length-1)
		}
		event.preventDefault();
	}

	validateBillingRuleFormControl() {
		var disableButton = this.billingRulesOptions.map((data) => {
			this.isValidFormControl = true;
			this.isValidFormControl = this.isValidFormControl && data.isValidBillingRules;
			return this.isValidFormControl;
		})
		if (disableButton.indexOf(false) >= 0 && this.billingRulesOptions.length > 0) return false;
		else return true;
	}

	// removeBillingRules(index) {
	// 	this.Modal.confirm({
	// 		header: this.$translate.instant('common.confirm_delete_title'),
	// 		message: this.$translate.instant('common.confirm_delete_message'),
	// 		callback: (({
	// 			modal,
	// 			$scope
	// 		}) => {
	// 			this.billingRulesOptions.splice(index, 1);
	// 			modal.close();
	// 		}),
	// 		negative: (({
	// 			modal,
	// 		}) => {
	// 			modal.close();
	// 		}),
	// 		type: 'danger'
	// 	})
	// }

	locationTypeOptionChoice(obj) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant',
			'coin-pickup', 'deposit-count', 'stop-completed'].indexOf(selectedBillingEvent) > -1) {
			obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['other'];
		}
		else if (['coin-delivery'].indexOf(selectedBillingEvent) > -1) {
			obj.locationTypeObj.locationTypeOptions = [...this.locationTypeOptions['other'], ...this.locationTypeOptions['ATM']];
		}
		else if (selectedBillingEvent == 'coin-conversion') {
			const option = { label: 'Any', value: 'any' };
			obj.locationTypeObj.locationTypeOptions = [option];
			obj.locationTypeObj.locationType = option;
		}
		else {
			obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['ATM'];
		}
	};

	serviceTypeOptionChoice(obj, index) {
		this.isDisableServiceTypeOptions[index] = { disabled: false };
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
			obj.serviceTypeObj.serviceTypeOptions = [this.serviceTypeOptions['other'][0], ...this.serviceTypeOptions['regular'], ...this.serviceTypeOptions['flm'], ...this.serviceTypeOptions['slm']];
			this.isDisableServiceTypeOptions[index].disabled = false;
		}
		else if (['stop-completed', 'atm-cash-delivery', 'coin-pickup', 'coin-delivery', 'shipment-delivery-cant', 'shipment-pickup',
			      'shipment-delivered', 'atm-cash-pickup', 'atm-deposit-pickup'].indexOf(selectedBillingEvent) > -1) {
			obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['other'];
			this.isDisableServiceTypeOptions[index].disabled = false;
		}
		else if (['atm-load-service', 'atm-load-cant'].indexOf(selectedBillingEvent) > -1) {
			obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['atmLoad'];
			this.isDisableServiceTypeOptions[index].disabled = false;
		}
		else {
			obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['none'];
			obj.serviceTypeObj.serviceType = this.serviceTypeOptions['none'][0];
			if (['deposit-count', 'atm-order-pack', 'pickup-deposit', 'atm-residual-deposit',
				 'delivery-order-pack', 'atm-residual-count', 'atm-deposit-count'].indexOf(selectedBillingEvent) > -1) {
				this.isDisableServiceTypeOptions[index].disabled = true;
			}
		}
	};

	orderTypeOptionChoice(obj) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'deposit-count'].indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = [...this.orderTypeOptions['cash_coin'], ...this.orderTypeOptions['cash_only'], ...this.orderTypeOptions['coin_only']];
		}
		else if (['atm-residual-count', 'atm-load-service', 'atm-order-pack', 'atm-residual-deposit', 'atm-deposit-pickup', 'atm-deposit-count', 'atm-load-cant', 'atm-cash-delivery', 'atm-cash-pickup']
			.indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['ATM'];
		}
		else if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['services'];
		}
		else if (['coin-pickup', 'coin-delivery'].indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['coin_only'];
		}
		else if (['stop-completed', 'coin-conversion'].indexOf(selectedBillingEvent) > -1) {
			const option = { label: 'Any', value: 'none' };
			obj.orderTypeObj.orderTypeOptions = [option];
			obj.orderTypeObj.orderType = option;
		}
		else {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['other'];
		}
	};

	validateBillingType(obj, index) {
		obj.dollarRate = null;
		obj.percentageRate = null;
		obj.dollarRateAbove = null;
		obj.percentageRateAbove = null;
		obj.dollarRateBelow = null;
		obj.percentageRateBelow = null;
		obj.itemThreshold = null;
		obj.valueThreshold = null;
		obj.timeThreshold = null;
		obj.itemIncrement = null;
		obj.valueIncrement = null;
		obj.timeIncrement = null;
		obj.applyWrapFee = false;
		obj.wrapFee = null;
		obj.billingTime = obj.billingEventObj.billingEvent && obj.billingEventObj.billingEvent.value === 'pre-bill' && obj.billingTypeObj.billingType.value === 'fixed' ? obj.billingTime = 'PRE' : 'POST';
		obj.locationDistanceId = null;
		obj.rateFirstHour = null;
		obj.rateFifteenMinutes = null;
		obj.serviceTimeTypeObj = {
			serviceTimeType: []
		},
		obj.overageRate = null;
		if (obj.billingTypeObj.billingType.value !== 'drive_distance') {
			this.model.useCustomerOnBillingRules === true ? this.getContractLocationList('',undefined,1,index) : this.getCustomerLocationList('',undefined,1,false,index);
		}
	}

	resetLocationAndServiceType(obj) {
		obj.serviceTypeObj.serviceTypeOptions = [];
		obj.locationTypeObj.locationTypeOptions = [];
	}

	generateBillingRules(type) {
		if (!this.billingRulesOptions.length) return [];
		this.contractRules = [];

		this.billingRulesOptions.forEach((obj) => {
			this.contractRules.push({
				name: obj.name,
				description: obj.description,
				generalLedgerCode: obj.generalLedgerCode || null,
				status: obj.status,
				billingEvent: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent[type] : null,
				billingEventLabel: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.label : null,
				locationType: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType[type] : 'NONE',
				locationTypeLabel: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType.label : 'NONE',
				serviceType: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType[type] : 'NONE',
				serviceTypeLabel: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType.label : 'NONE',
				scheduleType: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType[type] : 'NONE',
				scheduleTypeLabel: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType.label : 'NONE',
				orderType: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType[type] : 'NONE',
				orderTypeLabel: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType.label : 'NONE',
				billingType: obj.billingTypeObj && obj.billingTypeObj.billingType ? obj.billingTypeObj.billingType[type] : null,
				billingTypeLabel: obj.billingTypeObj && obj.billingTypeObj.billingType ? obj.billingTypeObj.billingType.label : null,
				dollarRate: obj.dollarRate >= 0 ? obj.dollarRate : null,
				percentageRate: obj.percentageRate >= 0 ? obj.percentageRate : null,
				dollarRateAbove: obj.dollarRateAbove >= 0 ? obj.dollarRateAbove : null,
				percentageRateAbove: obj.percentageRateAbove >= 0 ? obj.percentageRateAbove : null,
				dollarRateBelow: obj.dollarRateBelow >= 0 ? obj.dollarRateBelow : null,
				percentageRateBelow: obj.percentageRateBelow >= 0 ? obj.percentageRateBelow : null,
				itemThreshold: obj.itemThreshold >= 0 ? obj.itemThreshold : null,
				itemIncrement: obj.itemIncrement >= 0 ? obj.itemIncrement : null,
				valueThreshold: obj.valueThreshold >= 0 ? obj.valueThreshold : null,
				valueIncrement: obj.valueIncrement >= 0 ? obj.valueIncrement : null,
				timeThreshold: this.ifUndefined(obj.timeThreshold) ? obj.timeThreshold : null,
				timeIncrement: this.ifUndefined(obj.timeIncrement) ? obj.timeIncrement : null,
				currencyId: 'USD',
				applyWrapFee: obj.applyWrapFee,
				wrapFee: obj.wrapFee,
				billingTime: obj.billingTypeObj && obj.billingTypeObj.billingType && obj.billingTypeObj.billingType[type] === 'fixed' ? obj.billingTime : null,
				locationDistanceId: obj.locationDistanceId,
				rateFirstHour: obj.rateFirstHour,
				rateFifteenMinutes: obj.rateFifteenMinutes,
				serviceTimeType: obj.serviceTimeTypeObj.serviceTimeType.map(d => d.value).toString(),
				billToCustomerId: obj.billToCustomerId ? obj.billToCustomerId.Value : null,
				contractRulesLocations: obj.contractRulesLocations,
				preBillingEvents: obj.billingEventObj.preBillingEvents,
				postBillingEvents: obj.billingEventObj.postBillingEvents,
				contractRulesId: obj.contractRulesId,
				sequence: this.contractRules.length + 1,
				billableEventId: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.id : null,
				billingCategoryId: obj.billingCategoryObj && obj.billingCategoryObj.billingCategory ? obj.billingCategoryObj.billingCategory.billingCategoryId : null,
				overageRate: obj.overageRate,
				customerLocationsDistance: obj.customerLocationsDistance,
				contractLocationsDistance: obj.contractLocationsDistance,
				startDate: obj.startDate,
				endDate: obj.endDate ? obj.endDate : null,
			})
		})
	}

	setEditFlag(obj) {
		obj.isEdit = false;
	}

	saveBillingRules(obj, index) {
		this.loading = true;
		obj.isValidBillingRules = true;
		obj.timeThreshold = obj.timeThreshold ? this.getTime(obj.timeThreshold, obj.billingTypeObj.billingType['value']) : null;
		obj.timeIncrement = obj.timeIncrement ? this.getTime(obj.timeIncrement) : null;
		
		setTimeout(() => {
			this.model.contractStartDate = this.model.contractStartDate ? moment(this.model.contractStartDate).format('YYYY-MM-DD') : null;
			this.model.contractEndDate = this.model.contractEndDate ? moment(this.model.contractEndDate).format('YYYY-MM-DD') : null;
			const ruleEndDate = this.contractRules[index] && this.contractRules[index].endDate ? moment(this.contractRules[index].endDate).format('YYYY-MM-DD') : null;
			const ruleStartDate =  this.contractRules[index] && this.contractRules[index].startDate ? moment(this.contractRules[index].startDate).format('YYYY-MM-DD') : null;
			this.generateBillingRules('value');
			let contractRules = [];

			const type = 'value';

			new Array(this.billingRulesOptions[index]).forEach((obj) => {
				contractRules.push({
					name: obj.name,
					description: obj.description,
					generalLedgerCode: obj.generalLedgerCode || null,
					status: obj.status,
					billingEvent: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent[type] : null,
					billingEventLabel: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.label : null,
					locationType: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType[type] : 'NONE',
					locationTypeLabel: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType.label : 'NONE',
					serviceType: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType[type] : 'NONE',
					serviceTypeLabel: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType.label : 'NONE',
					scheduleType: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType[type] : 'NONE',
					scheduleTypeLabel: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType.label : 'NONE',
					orderType: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType[type] : 'NONE',
					orderTypeLabel: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType.label : 'NONE',
					billingType: obj.billingTypeObj.billingType[type],
					billingTypeLabel: obj.billingTypeObj.billingType.label,
					dollarRate: obj.dollarRate >= 0 ? obj.dollarRate : null,
					percentageRate: obj.percentageRate >= 0 ? obj.percentageRate : null,
					dollarRateAbove: obj.dollarRateAbove >= 0 ? obj.dollarRateAbove : null,
					percentageRateAbove: obj.percentageRateAbove >= 0 ? obj.percentageRateAbove : null,
					dollarRateBelow: obj.dollarRateBelow >= 0 ? obj.dollarRateBelow : null,
					percentageRateBelow: obj.percentageRateBelow >= 0 ? obj.percentageRateBelow : null,
					itemThreshold: obj.itemThreshold >= 0 ? obj.itemThreshold : null,
					itemIncrement: obj.itemIncrement >= 0 ? obj.itemIncrement : null,
					valueThreshold: obj.valueThreshold >= 0 ? obj.valueThreshold : null,
					valueIncrement: obj.valueIncrement >= 0 ? obj.valueIncrement : null,
					timeThreshold: this.ifUndefined(obj.timeThreshold) ? obj.timeThreshold : null,
					timeIncrement: this.ifUndefined(obj.timeIncrement) ? obj.timeIncrement : null,
					currencyId: 'USD',
					applyWrapFee: obj.applyWrapFee,
					wrapFee: obj.wrapFee,
					billingTime: obj.billingTypeObj.billingType[type] === 'fixed' ? obj.billingTime : null,
					locationDistanceId: obj.locationDistanceId,
					rateFirstHour: obj.rateFirstHour,
					rateFifteenMinutes: obj.rateFifteenMinutes,
					serviceTimeType: obj.serviceTimeTypeObj.serviceTimeType.map(d => d.value).toString(),
					billToCustomerId: obj.billToCustomerId ? obj.billToCustomerId.Value : null,
					contractRulesLocations: obj.contractRulesLocations,
					preBillingEvents: obj.billingEventObj.preBillingEvents,
					postBillingEvents: obj.billingEventObj.postBillingEvents,
					contractRulesId: obj.contractRulesId,
					sequence: obj.sequence,
					billableEventId: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.id : null,
					billingCategoryId: obj.billingCategoryObj && obj.billingCategoryObj.billingCategory ? obj.billingCategoryObj.billingCategory.billingCategoryId : null,
					recordStatus: !obj.contractRulesId ? 'new' : 'update',
					overageRate: obj.overageRate,
					customerLocationsDistance: obj.customerLocationsDistance,
					contractLocationsDistance: obj.contractLocationsDistance,
					startDate: obj.startDate ? moment(obj.startDate).format('YYYY-MM-DD') : null,
					endDate: obj.endDate ? moment(obj.endDate).format('YYYY-MM-DD') : null,
				})
			});
			if (this.billingRulesOptions[index].contractRulesId) {
				let contractRulesData = null;
				if (this.contractRules) {
					contractRulesData = this.contractRules[index];
				}

				const contractBillingRules = this.contractBillingRules[index];
				// const preBillingEvents = contractBillingRules.preBillingEvents ? contractBillingRules.preBillingEvents : [];
				const preBillingEvents = contractBillingRules.preBillingEvents ? contractBillingRules.preBillingEvents.map(function (e) { return e.id; }) : [];
				const postBillingEvents = contractBillingRules.postBillingEvents ? contractBillingRules.postBillingEvents.map(function (e) { return e.id; }) : [];

				let contractRulesPreBillingEvents = [];
				let contractRulesPostBillingEvents = [];
				if (contractRulesData) {
					if (contractRulesData.preBillingEvents) {
						contractRulesPreBillingEvents = contractRulesData.preBillingEvents.map(function (e) { return e.id; });
					}
					if (contractRulesData.postBillingEvents) {
						contractRulesPostBillingEvents = contractRulesData.postBillingEvents.map(function (e) { return e.id; });
					}
				}

				const diff = this.findDifferencesWithReturn({
					...contractBillingRules,
					preBillingEvents: preBillingEvents,
					postBillingEvents,
					startDate: ruleStartDate,
					endDate: ruleEndDate
				}, {
					...contractRulesData,
					preBillingEvents: contractRulesPreBillingEvents,
					postBillingEvents: contractRulesPostBillingEvents,
					startDate: this.billingRulesOptions[index].startDate ? moment(this.billingRulesOptions[index].startDate).format('YYYY-MM-DD') : null,
					endDate: this.billingRulesOptions[index].endDate ? moment(this.billingRulesOptions[index].endDate).format('YYYY-MM-DD') : null,
				});

				this.model.changedObj = diff;
			}

			this.model.contractRules = contractRules;
			this.contractRules.push(contractRules);

			this.model.billingIncrement = this.model.selectedBillingDuration;
			this.model.createdByUserId = this.User.getUser().id;
			this.model.modifiedByUserId = this.User.getUser().id;

			this.Service.updateContractRule(this.rawId, this.model, this.branchId).then((data) => {
				obj.isEdit = false;
				delete this.model.changedObj;
				data.results.forEach(info => {
					this.billingRulesOptions[index].contractRulesId = info.id;
					this.defaultModel.contractRulesData.push(info)
				})
				this.billingRulesOptions[index].isNew = false;
				this.generateContractBillingRules();
				if(!this.mainFormChanged){
					this.getContractDetails();
				}
				this.generateBillingRules('value')
				this.getContractRulesLocation();
			}).catch((err) => {
				obj.isEdit = true;
				if (err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.errorMessage = err.data.message;
				}
			})
				.finally(() => {
					this.loading = false;
				})
		}, 200)
		
		return false;
	}

	closeFormEdit(obj, i) {
		obj.isEdit = false;
		obj.isValidBillingRules = true;
		this.showAllFlag = false;
		this.billingRulesOptions[i] = {...this.tempEditValue[i], isEdit: false, isValidBillingRules: true};
		delete this.tempEditValue[i];
	}

	percentageMask(input, decimals) {
		return this.$filter('number')(input, decimals) + '%';
	}

	editBillingRules(obj, index) {

		let clonedObj = _.cloneDeep(obj);
		clonedObj.isEdit = true;
		obj.isEdit = clonedObj.isEdit;
		clonedObj.isValidBillingRules = false;
		obj.timeThreshold = obj.timeThreshold ? this.convertTimeThresholdValue(obj.timeThreshold) : null;
		obj.timeIncrement = obj.timeIncrement ? this.convertTimeThresholdValue(obj.timeIncrement) : null;
		this.tempEditValue = {...this.tempEditValue,[index]: clonedObj};
		//load filtered customerLocationDistance
		if (this.model.useCustomerOnBillingRules === false) {
			if (clonedObj.customerLocationsDistance && _.isEmpty(clonedObj.contractRulesLocations)) {
				this.locationDistance = clonedObj.locationDistanceId;
			}
			else if (_.isEmpty(clonedObj.customerLocationsDistance) && clonedObj.contractRulesLocations) {
				clonedObj.contractRulesLocations = [];
				this.locationDistance = clonedObj.locationDistanceId;
			}
			else if (clonedObj.contractRulesLocations.length !== clonedObj.customerLocationsDistance.length || !_.isEqual(clonedObj.contractRulesLocations, clonedObj.customerLocationsDistance)) {

				if (clonedObj.contractRulesLocations.every(location => clonedObj.customerLocationsDistance.includes(location))) {
					this.locationDistance = clonedObj.locationDistanceId;
				} else {
					clonedObj.contractRulesLocations = [];
					this.locationDistance = null; 
				}
			}
			else {
				this.locationDistance = clonedObj.locationDistanceId;
			}
			this.getCustomerLocationList('', clonedObj.locationDistanceId ? clonedObj.locationDistanceId : null , 1,false, index);
		}

		if (this.model.useCustomerOnBillingRules === true) {
			if (clonedObj.contractLocationsDistance && _.isEmpty(clonedObj.contractRulesLocations)) {
				this.contractLocationDistance = clonedObj.locationDistanceId;
			}
			else if (_.isEmpty(clonedObj.contractLocationsDistance) && clonedObj.contractRulesLocations) {
				clonedObj.contractRulesLocations = [];
				this.contractLocationDistance = clonedObj.locationDistanceId;
			}
			else if (clonedObj.contractRulesLocations.length !== clonedObj.contractLocationsDistance.length || !_.isEqual(clonedObj.contractRulesLocations, clonedObj.contractLocationsDistance)) {
				
				if (clonedObj.contractRulesLocations.every(location => clonedObj.contractLocationsDistance.includes(location))) {
					this.contractLocationDistance = clonedObj.locationDistanceId;
				} else {
					clonedObj.contractRulesLocations = [];
					this.contractLocationDistance = null;
				}
			}
			else {
				this.contractLocationDistance = clonedObj.locationDistanceId;
			}
			this.getContractLocationList('', clonedObj.locationDistanceId ? clonedObj.locationDistanceId : null , 1, index);
		}
	}

	duplicateBillingRule(obj) {
		const records = _.cloneDeep(obj);
		records.contractRulesId = null;
		records.isNew = true;
		records.sequence = this.billingRulesOptions.length + 1;
		this.editBillingRules(records)
		this.model.useCustomerOnBillingRules ? 
		this.getContractLocationList('', obj.locationDistanceId ? obj.locationDistanceId : null , 1, this.billingRulesOptions.length)
		: this.getCustomerLocationList('', obj.locationDistanceId ? obj.locationDistanceId : null , 1,false, this.billingRulesOptions.length);
		this.billingRulesOptions.push(records);
		this.validateStaticBillingOptions();
	}

	convertTimeThresholdValue(time) {
		if (!time) {
			return time;
		}

		if (time instanceof Date) {
			time = moment(time).format('HH:mm:ss');
		}

		time = time.split(':');

		let d = new Date();

		d.setHours(+time[0]);
		d.setMinutes(time[1]);
		d.setSeconds(time[2]);
		d.setMilliseconds(0);

		return d;
	}

	isInvalidForm() {
		return !this.model.contractId || !this.model.contractName || !this.model.selectedBillingDuration || (!this.model.contractStartDate && this.requiredStartDate) || !this.model.contractStartDate;
	}

	isBailmentInterestValid() {
		const bailmentInterestRegex = /^(?:100(?:\.0{1,2})?|([1-9][0-9]?|0)(?:\.[0-9]{1,2})?)%?$/;
		return this.model.bailmentInterest === null || this.model.bailmentInterest === '' || bailmentInterestRegex.test(this.model.bailmentInterest);
	}

	resetBillingRules(index) {
		this.billingRulesOptions[index] = this.existingBillingRules[index];
	}

	cloneExistingBillingRules(obj, index) {
		this.existingBillingRules[index] = {};
		this.existingBillingRules[index] = _.cloneDeep(obj);
	}

	ifUndefined(v, mixed) {
		return (typeof v === 'undefined' || v === null) ? mixed : v;
	};

	getBillableEvents() {
		this.billingEventOptions = [], this.contractBillingRules = []; this.preBillingEventOptions = []; this.postBillingEventOptions = [];
		this.BillableEventsService.all(null, 0, 100)
			.then((events) => {
				events.results.forEach(d => {
					this.preBillingEventOptions.push({
						id: d.id,
						label: this.$translate.instant(`entry_type.${d.type}`),
						value: d.type
					})
				})
				this.preBillingEventOptions = _.sortBy(this.preBillingEventOptions, ['label', 'ASC']);
				this.postBillingEventOptions = _.sortBy(this.preBillingEventOptions, ['label', 'ASC']);

				const billableEvents = events.results.reduce((acc, result) => {
					const categoryName = result.billingCategory.name;
					acc[categoryName] = acc[categoryName] || {
						billingEvents: [],
						billingCategoryId: result.billingCategoryId,
					};
					acc[categoryName].billingEvents.push({
						id: result.id,
						label: this.$translate.instant(`entry_type.${result.type}`),
						value: result.type
					});
					return acc;
				}, {});

				this.billingCategoryOptions = Object.keys(billableEvents).map(key => {
					return {
						label: key,
						billingCategoryId: billableEvents[key].billingCategoryId,
						billingEvents: billableEvents[key].billingEvents
					}
				});

				// this.billingEventOptions = _.sortBy(this.billingEventOptions, ['label', 'ASC']);
				// TODO: better solution for this
				this.contractRules.forEach((cr, index) => {

					if (cr.serviceTimeType) {
						const serviceTimeType = cr.serviceTimeType.split(',');
						this.serviceTimeTypes.forEach(stt => {
							serviceTimeType.forEach(v => {
								if (stt.value === v) {
									stt.ticked = true;
								}
							})
						})
					}

					this.billingRulesOptions.push({
						name: cr.name,
						description: cr.description,
						generalLedgerCode: cr.generalLedgerCode,
						status: cr.status,
						isValidBillingRules: true,
						billingEventObj: {
							billingEvent: null,
							billingEventOptions: null,
							preBillingEventOptions: _.cloneDeep(this.preBillingEventOptions),
							postBillingEventOptions: _.cloneDeep(this.postBillingEventOptions)
						},
						scheduleTypeObj: {
							scheduleType: cr.scheduleType ? _.find(this.scheduleTypeOptions, { 'value': cr.scheduleType.toLowerCase() }) : null,
							scheduleTypeOptions: this.scheduleTypeOptions
						},
						billingTypeObj: {
							billingType: cr.billingType ? _.find(this.billingTypeOptions, { 'value': cr.billingType.toLowerCase() }) : null,
							billingTypeOptions: this.billingTypeOptions
						},
						dollarRate: cr.dollarRate,
						percentageRate: cr.percentageRate,
						dollarRateAbove: cr.dollarRateAbove,
						percentageRateAbove: cr.percentageRateAbove,
						dollarRateBelow: cr.dollarRateBelow,
						percentageRateBelow: cr.percentageRateBelow,
						itemThreshold: cr.itemThreshold,
						valueThreshold: cr.valueThreshold,
						timeThreshold: this.formatTime(cr.timeThreshold, cr.billingType),
						itemIncrement: cr.itemIncrement,
						valueIncrement: cr.valueIncrement,
						timeIncrement: this.formatTime(cr.timeIncrement),
						isEdit: false,
						contractRulesId: cr.id,
						applyWrapFee: cr.applyWrapFee,
						wrapFee: cr.wrapFee,
						billingTime: cr.billingTime,
						locationDistanceId: cr.locationDistanceId,
						locationDistance: cr.locationDistance,
						rateFirstHour: cr.rateFirstHour,
						rateFifteenMinutes: cr.rateFifteenMinutes,
						serviceTimeTypeObj: {
							serviceTimeType: []
						},
						locationList: [],
						customerList: [],
						contractRulesLocations: _.cloneDeep(cr.locationApplicable),
						billToCustomerId: cr.customerId && cr.customer.isEnabled ? {
							Key: cr.customer.id + ' | ' + cr.customer.name,
							Value: cr.customer.id
						} : null,
						preBillingEvents: _.cloneDeep(cr.preBillingEvents),
						postBillingEvents: _.cloneDeep(cr.postBillingEvents),
						sequence: cr.sequence,
						billableEventId: cr.billableEventId,
						billingCategoryId: cr.billingCategoryId,
						billingCategoryObj: {
							billingCategory: {
								label: cr.billingCategory ? cr.billingCategory.name : null,
								billingCategoryId: cr.billingCategory ? cr.billingCategory.id : null,
								billingEvents: cr.billingCategory ? this.billingCategoryOptions.filter(d => d.billingCategoryId === cr.billingCategory.id).map(c => c.billingEvents) : []
							},
							billingCategoryOptions: _.cloneDeep(this.billingCategoryOptions)
						},
						extraDetails: {
							billingType: cr.billingType,
							billingEvent: cr.billingEvent,
							locationType: cr.locationType,
							serviceType: cr.serviceType,
							orderType: cr.orderType
						},
						overageRate: cr.overageRate,
						customerLocationsDistance: _.cloneDeep(cr.customerLocationsDistance),
						contractLocationsDistance: _.cloneDeep(cr.contractLocationsDistance),
						locationOptions: [],
						startDate: cr.startDate ? this.DateUtil.convertToDate(cr.startDate): null,
						endDate: cr.endDate ? this.DateUtil.convertToDate(cr.endDate) : null
					})
				})

				this.billingRulesOptions.forEach((br, index) => {
					let preBillingEvents = [], postBillingEvents = [];
					if (br.extraDetails.billingType) this.billingTypeOptionChoice(br);

					br.billingEventObj.preBillingEventOptions.forEach((pbe) => {
						if (br.preBillingEvents.includes(pbe.id)) {
							preBillingEvents.push(pbe)
							pbe.ticked = true;
						}
					})

					br.billingEventObj.postBillingEventOptions.forEach((pbe) => {
						if (br.postBillingEvents.includes(pbe.id)) {
							postBillingEvents.push(pbe);
							pbe.ticked = true;
						}
					})

					br.billingEventObj.billingEventOptions = br.billingCategoryObj.billingCategory.billingEvents && br.billingCategoryObj.billingCategory.billingEvents.length > 0 ? br.billingCategoryObj.billingCategory.billingEvents[0] : [];

					const billingEvent = br.extraDetails.billingEvent ? _.find(br.billingEventObj.billingEventOptions, { 'value': br.extraDetails.billingEvent }) : null;

					br.billingEventObj.billingEvent = billingEvent;
					br.billingEventObj.preBillingEvents = preBillingEvents;
					br.billingEventObj.postBillingEvents = postBillingEvents;

					let selectedBillingEvent;
					if (billingEvent) {
						selectedBillingEvent = billingEvent.value;
					} else {
						selectedBillingEvent = br.extraDetails.billingEvent;
					}
					const locationTypeOptions = 
						selectedBillingEvent === 'coin-delivery' ? [...this.locationTypeOptions['other'], ...this.locationTypeOptions['ATM']] :
						selectedBillingEvent === 'coin-conversion' ?  [this.locationTypeOptions.other[0]] :
						br.extraDetails.locationType && ['any', 'regular', 'nsng', 'on_call', 'bank'].includes(br.extraDetails.locationType.toLowerCase()) ? this.locationTypeOptions['other'] : this.locationTypeOptions['ATM'];
					
					const serviceTypeOptions = this.loadServiceTypeOptionChoice(selectedBillingEvent, br.extraDetails.serviceType, index);

					if (selectedBillingEvent === 'coin-conversion') {
						let perItemOption = this.billingTypeOptions.find(bt => bt.value === 'per_item');
						br.billingTypeObj.billingTypeOptions = [perItemOption];
						br.billingTypeObj.billingType = { label: "Per Item", value: "per_item" };
					}
					else if (selectedBillingEvent === 'atm-residual-count') {
						const options = this.billingTypeOptions.filter(bt => ['fixed', 'per_item', 'percentage_fee'].includes(bt.value));
						br.billingTypeObj.billingTypeOptions = options;
					}

					let orderTypeOptions = [];

					br.locationTypeObj = {
						locationType: br.extraDetails.locationType ? _.find(locationTypeOptions, { 'value': br.extraDetails.locationType.toLowerCase() }) : null,
						locationTypeOptions: locationTypeOptions
					};
					br.serviceTypeObj = {
						serviceType: br.extraDetails.serviceType ? _.find(serviceTypeOptions, { 'value': br.extraDetails.serviceType.toLowerCase() }) : null,
						serviceTypeOptions: serviceTypeOptions
					};

					if (br.extraDetails.orderType) {
						if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'deposit-count'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = [...this.orderTypeOptions['cash_coin'], ...this.orderTypeOptions['cash_only'], ...this.orderTypeOptions['coin_only']];
						}
						else if (['atm-residual-count', 'atm-load-service', 'atm-order-pack', 'atm-residual-deposit', 'atm-deposit-pickup', 'atm-deposit-count', 'atm-load-cant', 'atm-cash-delivery', 'atm-cash-pickup']
							.indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = this.orderTypeOptions['ATM'];
						}
						else if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = this.orderTypeOptions['services'];
						}
						else if (['coin-pickup', 'coin-delivery'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = this.orderTypeOptions['coin_only'];
						}
						else if (['stop-completed', 'coin-conversion'].indexOf(selectedBillingEvent) > -1) {
							const option = { label: 'Any', value: 'none' };
							orderTypeOptions = [option];
						}
						else {
							orderTypeOptions = this.orderTypeOptions['other'];
						}
					}

					br.orderTypeObj = {
						orderType: br.extraDetails.orderType ? _.find(orderTypeOptions, { 'value': br.extraDetails.orderType.toLowerCase() }) : null,
						orderTypeOptions: orderTypeOptions
					};
				})

				this.billingRulesOptions.forEach(br => {
					this.contractBillingRules.push({
						name: br.name,
						description: br.description,
						generalLedgerCode: br.generalLedgerCode || null,
						status: br.status,
						billingEvent: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent['value'] : null,
						billingEventLabel: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.label : null,
						locationType: br.locationTypeObj.locationType ? br.locationTypeObj.locationType['value'] : 'NONE',
						locationTypeLabel: br.locationTypeObj.locationType ? br.locationTypeObj.locationType.label : 'NONE',
						serviceType: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType['value'] : 'NONE',
						serviceTypeLabel: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType.label : 'NONE',
						scheduleType: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType['value'] : 'NONE',
						scheduleTypeLabel: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType.label : 'NONE',
						orderType: br.orderTypeObj.orderType ? br.orderTypeObj.orderType['value'] : 'NONE',
						orderTypeLabel: br.orderTypeObj.orderType ? br.orderTypeObj.orderType.label : 'NONE',
						billingType: br.billingTypeObj.billingType['value'],
						billingTypeLabel: br.billingTypeObj.billingType.label,
						dollarRate: br.dollarRate >= 0 ? br.dollarRate : null,
						percentageRate: br.percentageRate >= 0 ? br.percentageRate : null,
						dollarRateAbove: br.dollarRateAbove >= 0 ? br.dollarRateAbove : null,
						percentageRateAbove: br.percentageRateAbove >= 0 ? br.percentageRateAbove : null,
						dollarRateBelow: br.dollarRateBelow >= 0 ? br.dollarRateBelow : null,
						percentageRateBelow: br.percentageRateBelow >= 0 ? br.percentageRateBelow : null,
						itemThreshold: br.itemThreshold >= 0 ? br.itemThreshold : null,
						itemIncrement: br.itemIncrement >= 0 ? br.itemIncrement : null,
						valueThreshold: br.valueThreshold >= 0 ? br.valueThreshold : null,
						valueIncrement: br.valueIncrement >= 0 ? br.valueIncrement : null,
						timeThreshold: this.ifUndefined(br.timeThreshold) ? br.timeThreshold : null,
						timeIncrement: this.ifUndefined(br.timeIncrement) ? br.timeIncrement : null,
						currencyId: 'USD',
						applyWrapFee: br.applyWrapFee,
						wrapFee: br.wrapFee,
						billingTime: br.billingTypeObj.billingType['value'] === 'fixed' ? br.billingTime : null,
						locationDistanceId: br.locationDistanceId,
						rateFirstHour: br.rateFirstHour,
						rateFifteenMinutes: br.rateFifteenMinutes,
						serviceTimeType: br.serviceTimeTypeObj.serviceTimeType.map(d => d.value).toString(),
						billToCustomerId: br.billToCustomerId ? br.billToCustomerId.Value : null,
						contractRulesLocations: br.contractRulesLocations,
						preBillingEvents: br.billingEventObj.preBillingEvents,
						postBillingEvents: br.billingEventObj.postBillingEvents,
						contractRulesId: br.contractRulesId,
						sequence: br.sequence,
						billableEventId: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.id : null,
						billingCategoryId: br.billingCategoryObj && br.billingCategoryObj.billingCategory ? br.billingCategoryObj.billingCategory.billingCategoryId : null,
						overageRate: br.overageRate,
						customerLocationsDistance: br.customerLocationsDistance,
						contractLocationsDistance: br.contractLocationsDistance,
						startDate: br.startDate,
						endDate: br.endDate
					})
				})
				this.validateStaticBillingOptions();
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				// this.loading = false;
				this.contractDatesChanged();
			})
	}

	getBillingEventsByCategory(contractRuleObj, index) {
		this.resetLocationAndServiceType(contractRuleObj);
		contractRuleObj.billingEventObj.billingEventOptions = contractRuleObj.billingCategoryObj.billingCategory.billingEvents;
	}

	locationDistanceList() {
		this.LocationDistanceService.all(null, 0, 100)
			.then((data) => {
				this.model.locationDistanceOptions = data.results;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	updateLocationDistance(contractRules, locationDistanceId, index) {
		setTimeout(() => {
			const page = 1;
			const selectAllFlag = false;
	
			contractRules.locationDistance = _.find(this.model.locationDistanceOptions, { 'id': locationDistanceId });
			this.showAllFlag = false;

			if (this.model.useCustomerOnBillingRules) {
				this.getContractLocationList('', contractRules.locationDistanceId, page, index);
			} else {
				this.getCustomerLocationList('', contractRules.locationDistanceId, page, selectAllFlag, index);
			}
	
			setTimeout(() => {
				const applicableLocations = this.model.useCustomerOnBillingRules ? this.locationObj.results : this.associateLocationObj.results;

					let filteredLocations;
				if(this.billingRulesOptions[index].isNew == true){
					filteredLocations = applicableLocations
						.filter((ele) => this.billingRulesOptions[index].contractRulesLocations.includes(ele.value))
						.map((ele) => ele.value);
				} else {
					filteredLocations = applicableLocations
						.filter((ele) => this.contractRules[index].locationApplicable.includes(ele.value))
						.map((ele) => ele.value);
				}
				
				this.billingRulesOptions[index].contractRulesLocations = filteredLocations.length > 0 ? filteredLocations : [];
				this.$scope.$apply()
			}, 500);
		});
	}

	preOrPostBillCfg(obj, index) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (this.staticBillingEvents.includes(selectedBillingEvent)) {
			this.disableOtherOptions[index] = {
				disabled: true
			};
			obj.locationTypeObj.locationType = null;
			obj.serviceTypeObj.serviceType = null;
			obj.scheduleTypeObj.scheduleType = null;
			obj.orderTypeObj.orderType = null;
			obj.billingTypeObj.billingType = {
				label: 'Fixed',
				value: 'fixed'
			}
			obj.billingTime = selectedBillingEvent === 'pre-bill' ? 'PRE' : 'POST';
			obj.dollarRate = null;
			obj.percentageRate = null;
			obj.dollarRateAbove = null;
			obj.percentageRateAbove = null;
			obj.dollarRateBelow = null;
			obj.percentageRateBelow = null;
			obj.itemThreshold = null;
			obj.valueThreshold = null;
			obj.timeThreshold = null;
			obj.itemIncrement = null;
			obj.valueIncrement = null;
			obj.timeIncrement = null;
			obj.isEdit = true;
			obj.applyWrapFee = false;
			obj.wrapFee = null;
			obj.locationDistanceId = null;
			obj.rateFirstHour = null;
			obj.rateFifteenMinutes = null;
			obj.overageRate = null;
			this.model.selectedBillingDuration = 'MONTHLY';
			this.model.disableBillingIncrement = true;
			this.requiredStartDate = true;
		}
		else {
			this.model.disableBillingIncrement = false;
			this.disableOtherOptions[index] = {
				disabled: false
			};
			obj.billingTime = 'POST';
			this.requiredStartDate = false;
			obj.billingTypeObj.billingType = null;
			setTimeout(() => {
				obj.billingEventObj.preBillingEvents = [];
				obj.billingEventObj.preBillingEventOptions.forEach((pbe) => {
					pbe.ticked = false;
				})

				obj.billingEventObj.postBillingEvents = [];
				obj.billingEventObj.postBillingEventOptions.forEach((pbe) => {
					pbe.ticked = false;
				})
			})
		}

		this.isStartDateIsRequired();
	}

	isAllowScheduleType(obj, index) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (this.allowScheduleTypeBillingEvents.includes(selectedBillingEvent)) {
			this.disableScheduleTypeOptions[index] = {
				disabled: true
			};
			obj.scheduleTypeObj.scheduleType = null;
		}
		else {
			this.disableScheduleTypeOptions[index] = {
				disabled: false
			};
		}
	}

	isStartDateIsRequired() {
		if (!this.billingRulesOptions.length) this.requiredStartDate = false;

		this.billingRulesOptions.forEach((br) => {
			if (br.billingEventObj.billingEvent && br.billingEventObj.billingEvent.value == "pre-bill") this.requiredStartDate = true;
		})
	}


	resetBillToCustomers() {
		const filterEdits = this.billingRulesOptions.filter((obj) => obj.isEdit === true);
		this.billingRulesOptions.forEach((obj) => {
			obj.billToCustomerId = null;
			obj.contractRulesLocations = [];
			obj.locationOptions = [];
			obj.isEdit = false;
		})
		this.formValues = angular.copy(this.model);
		if(filterEdits.length){
			filterEdits.map((ele) => {
				this.editBillingRules(ele, ele.sequence-1)
			})
		}
	}

	billingTypeOptionChoice(obj) {
		if (!obj.billingEventObj.billingEvent) return;

		const selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (!selectedBillingEvent) return;

		if (this.staticBillingEvents.includes(selectedBillingEvent)) {
			let fixedOption = this.billingTypeOptions.find(bt => bt.label === 'Fixed');
			obj.billingTypeObj.billingTypeOptions = [fixedOption];
		} 
		else if(selectedBillingEvent === 'stop-completed') {
			const options = this.billingTypeOptions.filter(bt => ['fixed', 'per_item'].includes(bt.value));
			obj.billingTypeObj.billingTypeOptions = options;
		}
		else if (selectedBillingEvent === 'coin-conversion') {
			let perItemOption = this.billingTypeOptions.find(bt => bt.value === 'per_item');
			obj.billingTypeObj.billingTypeOptions = [perItemOption];
			obj.billingTypeObj.billingType = { label: "Per Item", value: "per_item" };
		}
		else if (selectedBillingEvent === 'atm-residual-count') {
			const options = this.billingTypeOptions.filter(bt => ['fixed', 'per_item', 'percentage_fee'].includes(bt.value));
			obj.billingTypeObj.billingTypeOptions = options;
		}
		else {
			obj.billingTypeObj.billingTypeOptions = this.billingTypeOptions;
		}
	};

	bulkImportLocationModal(data, index) {
		data.contractId = this.model.contractId;
		data.useCustomerOnBillingRules = this.model.useCustomerOnBillingRules;
		data.showAll = this.showAllFlag;
		this.Modal.bulkImportLocation(data, ({ locationList, modal }) => {
			if (locationList && locationList.length > 0) {
				locationList.forEach(l1 => {
					data.contractRulesLocations.push(l1)
				})
			}
			modal.close();
		}, ({ modal }) => {
			if (modal) modal.close();
		})
	}

	getCustomerList(searchKey, offset) {
		this.customerObj.loading = true;
		this.Service.getCustomerList(searchKey, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.customerObj.totalRecords = data.totalRecords;
					this.customerObj.results = this.dataMapping(data.results, 'key', 'value');
				} else {
					const customers = this.dataMapping(data.results, 'key', 'value');
					this.customerObj.results = this.customerObj.results.concat(customers);
				}
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.customerObj.loading = false;
			})
	}

	dataMapping(data, key, value) {
		return data.map((obj) => {
			return {
				Key: obj[key],
				Value: obj[value]
			}
		});
	}

	getContractLocationList(searchKey = '', locationDistanceId, page = 1, index = null, selectAllFlag = false) {
		setTimeout(() => {
			let queryDataLimit = selectAllFlag ? (this.locationObj.totalLocations || this.contractLocationListObj.pagination.pageLimit) : this.contractLocationListObj.pagination.pageLimit;
			this.Service.contractLocationList(searchKey, locationDistanceId, (page - 1) * this.contractLocationListObj.pagination.pageLimit, queryDataLimit)
			.then((res) => {
						if (page == 1) {
							this.locationObj.results = [];
							if(index !== null){
								this.billingRulesOptions[index].locationOptions = [];
							}
						}
						if(this.billingRulesOptions[index] && this.billingRulesOptions[index].locationOptions){	
								this.billingRulesOptions[index].locationOptions =  _.cloneDeep(_.uniqBy(this.billingRulesOptions[index].locationOptions.concat(res.results), 'value'));
						}
			
						this.locationObj.results = _.uniqBy(this.locationObj.results.concat(res.results), 'value');
						this.locationObj.totalLocations = res.totalRecords;

						if(index !== null && this.billingRulesOptions[index]){
							this.billingRulesOptions[index].contractLocationsDistance = new Array(res.totalRecords).fill('');
						}
				})
				.catch((err) => {
					console.log(err);
				})
		})
	}

	getCustomerLocationList(searchKey = '', locationDistanceId, page = 1, selectAllFlag = false, index) {
		setTimeout(() => {
			let queryDataLimit = selectAllFlag ? this.associateLocationObj.totalLocations : this.contractLocationListObj.pagination.pageLimit
			this.Service.getCustomerLocationList(this.model.contractId, locationDistanceId, searchKey, (page - 1) * this.contractLocationListObj.pagination.pageLimit, queryDataLimit)
				.then((res) => {
					if (res.results) {
						if (page == 1) {
							this.associateLocationObj.results = [];
							if(index !== null && this.billingRulesOptions[index]){
								this.billingRulesOptions[index].locationOptions = [];
							}
						}
	
						this.associateLocationObj.results = _.uniqBy(this.associateLocationObj.results.concat(res.results), 'value');
						this.associateLocationObj.totalLocations = res.totalRecords;

						setTimeout(() => {
							if (selectAllFlag && index >= 0 && this.contractRules[index] && this.contractRules[index].isNew === false) {
								this.contractRules[index].locationApplicable = this.associateLocationObj.results.map(el => el.value)
								// this.billingRulesOptions[index].locationApplicable = this.associateLocationObj.results.map(el => el.value)
							}
						}, 500);
						if(this.billingRulesOptions[index] && this.billingRulesOptions[index].locationOptions){
							this.billingRulesOptions[index].locationOptions = _.cloneDeep(_.uniqBy(this.billingRulesOptions[index].locationOptions.concat(res.results), 'value'));
						}
						
						if(index >= 0){
							this.billingRulesOptions[index].customerLocationsDistance = new Array(res.totalRecords).fill('')
						}
					}
				})
				.catch((err) => {
					console.log(err);
				})
		})
	}

	filterChange(contractRules) {
		// console.log(contractRules.contractRulesLocations)
	}

	clear() {
		this.model.contractEndDate = null;
	}

	findDifferences(obj1Array, obj2Array) {
		let resultObjects = [];
		function compareObjects(obj1, obj2) {
			for (let key in obj1) {
				if (obj1.hasOwnProperty(key)) {
					if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
						if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
							return true; // Object properties differ
						}
					} else if (obj1[key] !== obj2[key]) {
						return true; // Primitive values differ
					}
				}
			}
			return false;
		}

		obj2Array.forEach(obj2 => {
			let obj1 = obj1Array.find(o => o.contractRulesId === obj2.contractRulesId);
			if (obj1) {
				let isUpdated = compareObjects(obj1, obj2);
				let updatedObject = { ...obj2, recordStatus: isUpdated ? 'update' : 'noChange' };
				resultObjects.push(updatedObject);
			}
			else {
				resultObjects.push({ ...obj2, recordStatus: 'new' });
			}
		});

		return resultObjects;
	}

	updateContractRuleStatus(index, isActive) {
		setTimeout(() => {
			const id = isActive ? `active-btn-${index}` : `inactive-btn-${index}`;
			return document.getElementById(id).blur();
		});
		if(this.billingRulesOptions[index].isNew || this.billingRulesOptions[index].isEdit) return
		this.updateContractStats(this.billingRulesOptions);
	}

	validateRecordOnSequenceChange() {
		setTimeout(() => {
			this.disableOtherOptions = {};
			this.billingRulesOptions.forEach((cr, index) => {
				if (cr.billingEventObj.billingEvent && this.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
					this.disableOtherOptions[index] = {
						disabled: true
					}
					this.requiredStartDate = true;
				}
				else {
					this.disableOtherOptions[index] = {
						disabled: false
					}
					this.requiredStartDate = false;
				}
				this.isAllowScheduleType(cr, index);
			}, 100)
		})
	};

	validateStaticBillingOptions() {
		setTimeout(() => {
			this.disableOtherOptions = {};
			this.billingRulesOptions.forEach((cr, index) => {
				if (cr.billingEventObj.billingEvent && this.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
					this.disableOtherOptions[index] = {
						disabled: true
					}
					this.requiredStartDate = true;
				}
				else {
					this.disableOtherOptions[index] = {
						disabled: false
					}
					this.requiredStartDate = false;
				}
				this.isAllowScheduleType(cr, index);
			})
			this.$scope.$apply()

		}, 100)
	}

	handleFormChange() {
		let keys = [
			'contractName',
			'status',
			'selectedBillingDuration',
			'contractStartDate',
			'contractEndDate',
			'useCustomerOnBillingRules',
			"selectedBillingDuration"
		];

		const formTemp = {};
		const modalTemp = {};

		keys.forEach(key => {
			if (['contractStartDate', 'contractEndDate'].includes(key)) {
				formTemp[key] = this.formValues[key] ? moment(this.formValues[key]).startOf('day').toDate() : null;
				modalTemp[key] = this.model[key] ? moment(this.model[key]).startOf('day').toDate() : null;
			} else {
				formTemp[key] = this.formValues[key];
				modalTemp[key] = this.model[key];

				if (key === 'useCustomerOnBillingRules' && this.formValues[key]) {
					this.billingRulesOptions.forEach((crl) => {
						crl.contractRulesLocations = []
					})
				}
				if (this.model.useCustomerOnBillingRules === true) {
					this.billingRulesOptions.forEach((crl, index) => {
						if (this.contractRules[index]) {
							crl.contractRulesLocations = this.contractRules[index].locationApplicable;
						}
					})
				}
			}
		});
		this.mainFormChanged = !angular.equals(formTemp, modalTemp);
	}

	changeSeq() {
		this.model.contractStartDate = this.model.contractStartDate ? moment(this.model.contractStartDate).format('YYYY-MM-DD') : null;
		this.model.contractEndDate = this.model.contractEndDate ? moment(this.model.contractEndDate).format('YYYY-MM-DD') : null;
		this.generateBillingRules('value');
		let contractRules;
		contractRules = this.findDifferences(this.contractBillingRules, this.contractRules)
		const formattedContractRules = contractRules.map((item) => {
			return {
				...item,
				startDate: item.startDate ? moment(item.startDate).format('YYYY-MM-DD') : null,
				endDate: item.endDate ? moment(item.endDate).format('YYYY-MM-DD') : null,
			};
		});
		this.model.contractRules = formattedContractRules;
		this.model.billingIncrement = this.model.selectedBillingDuration;
		this.model.createdByUserId = this.User.getUser().id;
		this.model.modifiedByUserId = this.User.getUser().id;
		this.loading = true;
		this.Service.updateContractRule(this.rawId, this.model, this.branchId)
			.then((data) => {
				this.getContractDetails()

			}).catch((err) => {
				if (err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.errorMessage = err.data.message;
				}
			})
			.finally(() => {
				this.loading = false;
			})
	}

	onDrop(event, index, item, external, type) {
		// Create a copy of the billingRulesOptions array
		const updatedOptions = angular.copy(this.billingRulesOptions);

		// Remove the item from its original position
		const itemIndex = updatedOptions.findIndex((opt) => opt.contractRulesId === item.contractRulesId);
		updatedOptions.splice(itemIndex, 1);

		// Reinsert the item at the new position
		updatedOptions.splice(index, 0, item);

		// Update the sequence field for all items in the updatedOptions array
		updatedOptions.forEach((opt, i) => {
			opt.sequence = i + 1;
		});

		this.generateContractBillingRules();

		// Update the billingRulesOptions array with the new changes
		this.billingRulesOptions = updatedOptions;

		this.validateRecordOnSequenceChange();
		this.changeSeq();
		// this.serviceTypeOptionChoice(item, index);

		return true;
	}

	checkIsEdit() {
		return this.billingRulesOptions.some((ele, i) => ele.isEdit === true)
	}

	print() {
		const searchObj = this.generateSearchObj();

		this.Service.getContractLogs(this.$stateParams.id, searchObj, 0, 10000)
			.then(data => {
				let printLogsData; 
				printLogsData = data.results.map(log => {
					log.readableEntryType = this.$translate.instant('entry_type.' + log.entryType);
					if (log.entryData) {
						log.extraDetails = Object.entries(log.entryData).map(([key, value]) => ({
							key,
							value: typeof value === 'object' ? JSON.stringify(value) : value
						}));
					}
					return log;
				});
				const obj = {
					results: printLogsData,
					contractDetails: {
						contractName: this.model.contractName,
						contractId: this.model.contractId
					}
				}
				let url = this.$state.href('printHistory');
				window.w = window.open(url, '_blank');
				window.w.printData = obj;
			})
			.catch(error => {
				console.error('Error loading contract logs:', error);
			})
			.finally(() => {
				this.loading = false;
			});
	}

	exportToCsv() {
		this.isExporting = true;
		const searchObj = this.generateSearchObj();
		this.Service.exportDataToCSV(this.model.contractId, searchObj).then((data) => {
			const date = moment.utc().format('DDMMYY');
			this.fileName = this.filePrefix.concat('_', date, '.csv');
			let a = document.createElement("a");
			document.body.appendChild(a);
			let file = new Blob([data.results], { type: 'application/csv' });
			let fileURL = window.URL.createObjectURL(file);
			a.href = fileURL;
			a.download = this.fileName;
			a.click();
			this.isExporting = false;
		})
	}

	getContractTypeList(searchKey, offset) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "type",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

		this.contractTypeObj.loading = true;
		return this.ContractTypeService.all(obj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.contractTypeObj.totalRecords = data.total;
					this.contractTypeObj.results = this.mapContractData(data.results);
				} else {
					const contaractType = this.mapContractData(data.results);
					this.contractTypeObj.results = this.contractTypeObj.results.concat(contaractType);
				}
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.contractTypeObj.loading = false;
			})
	}

	mapContractData(mapArray) {
		return mapArray.map((obj) => {
			return {
				Key: obj.type,
				Value: obj.id
			}
		});
	}

	convertStr(str) {
		if (!str) return;
		return Number(str.replace('%', ''));
	}

	ngPercentage() {
		if (this.model.bailmentInterest && !this.model.bailmentInterest.endsWith('%')) {
			return this.model.bailmentInterest = this.model.bailmentInterest + '%';
		}
	}

	removePercentageSign() {
		if (this.model.bailmentInterest && this.model.bailmentInterest.endsWith('%')) {
			return this.model.bailmentInterest = this.model.bailmentInterest.replace('%', '');
		}
	}

	findDifferencesWithReturn(objA, objB) {

		function compareObjects(obj1, obj2) {
			let diff = {};
			diff.name = obj1.name;

			for (let key in obj1) {
				if (obj1.hasOwnProperty(key)) {
					if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
						if (Array.isArray(obj1[key])) {
							// Sort the arrays before comparing
							obj1[key].sort();
							obj2[key].sort();

							if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
							const nestedDiff = compareObjects(obj1[key], obj2[key]);
							if (Object.keys(nestedDiff).length > 0) {
								diff[key] = nestedDiff;
							}
						}
					} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
						if (key === 'status') {
							diff[key] = {
								"Old Value": obj1[key] ? "Active" : "Suspended",
								"Updated Value": obj2[key] ? "Active" : "Suspended"
							};
						} else {
							diff[key] = {
								"Old Value": obj1[key],
								"Updated Value": obj2[key]
							};
						}
					}
				}
			}

			Object.keys(diff).map(k => {
				if (['billingEventLabel', 'locationTypeLabel', 'orderTypeLabel', 'billingTypeLabel', 'serviceTypeLabel', 'sequence', 'contractLocationsDistance'].includes(k)) {
					delete diff[k];
				}
			});

			return diff;
		}

		return compareObjects(objA, objB);
	}

	resetLogsOptions(){
		this.page = 1;
		this.searchText = '';
		this.entryType = undefined;
		this.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
		this.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
		this.contractRulesLocationSearchText = ''
		this.getContractRulesLocation()
	}

	generateContractBillingRules(){
		this.contractBillingRules = []
		this.billingRulesOptions.forEach(br => {
			this.contractBillingRules.push({
				name: br.name,
				description: br.description,
				generalLedgerCode: br.generalLedgerCode || null,
				status: br.status,
				billingEvent: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent['value'] : null,
				billingEventLabel: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.label : null,
				locationType: br.locationTypeObj.locationType ? br.locationTypeObj.locationType['value'] : 'NONE',
				locationTypeLabel: br.locationTypeObj.locationType ? br.locationTypeObj.locationType.label : 'NONE',
				serviceType: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType['value'] : 'NONE',
				serviceTypeLabel: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType.label : 'NONE',
				scheduleType: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType['value'] : 'NONE',
				scheduleTypeLabel: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType.label : 'NONE',
				orderType: br.orderTypeObj.orderType ? br.orderTypeObj.orderType['value'] : 'NONE',
				orderTypeLabel: br.orderTypeObj.orderType ? br.orderTypeObj.orderType.label : 'NONE',
				billingType: br.billingTypeObj.billingType ? br.billingTypeObj.billingType['value'] : 'NONE',
				billingTypeLabel: br.billingTypeObj.billingType ? br.billingTypeObj.billingType.label : 'NONE',
				dollarRate: br.dollarRate >= 0 ? br.dollarRate : null,
				percentageRate: br.percentageRate >= 0 ? br.percentageRate : null,
				dollarRateAbove: br.dollarRateAbove >= 0 ? br.dollarRateAbove : null,
				percentageRateAbove: br.percentageRateAbove >= 0 ? br.percentageRateAbove : null,
				dollarRateBelow: br.dollarRateBelow >= 0 ? br.dollarRateBelow : null,
				percentageRateBelow: br.percentageRateBelow >= 0 ? br.percentageRateBelow : null,
				itemThreshold: br.itemThreshold >= 0 ? br.itemThreshold : null,
				itemIncrement: br.itemIncrement >= 0 ? br.itemIncrement : null,
				valueThreshold: br.valueThreshold >= 0 ? br.valueThreshold : null,
				valueIncrement: br.valueIncrement >= 0 ? br.valueIncrement : null,
				timeThreshold: this.ifUndefined(br.timeThreshold) ? br.timeThreshold : null,
				timeIncrement: this.ifUndefined(br.timeIncrement) ? br.timeIncrement : null,
				currencyId: 'USD',
				applyWrapFee: br.applyWrapFee,
				wrapFee: br.wrapFee,
				billingTime: br.billingTypeObj.billingType ? br.billingTypeObj.billingType['value'] === 'fixed' ? br.billingTime : null : 'NONE',
				locationDistanceId: br.locationDistanceId,
				rateFirstHour: br.rateFirstHour,
				rateFifteenMinutes: br.rateFifteenMinutes,
				serviceTimeType: br.serviceTimeTypeObj.serviceTimeType.map(d => d.value).toString(),
				billToCustomerId: br.billToCustomerId ? br.billToCustomerId.Value : null,
				contractRulesLocations: br.contractRulesLocations,
				preBillingEvents: br.billingEventObj.preBillingEvents,
				postBillingEvents: br.billingEventObj.postBillingEvents,
				contractRulesId: br.contractRulesId,
				sequence: br.sequence,
				billableEventId: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.id : null,
				billingCategoryId: br.billingCategoryObj && br.billingCategoryObj.billingCategory ? br.billingCategoryObj.billingCategory.billingCategoryId : null,
				overageRate: br.overageRate,
				customerLocationsDistance: br.customerLocationsDistance,
				contractLocationsDistance: br.contractLocationsDistance,
				startDate: br.startDate,
				endDate: br.endDate
			})
		})
	}

	getContractRulesLocation() {
		this.contractRulesLocationLoading = true;
		this.billingRulesOptions = [];
		this.Service.getContractRulesLocation(this.model.contractId, this.contractRulesLocationSearchText)
			.then((data) => {
				this.contractRules = data.contractRulesData;
				this.getBillableEvents();
				this.updateContractStats(data.contractRulesData);
				// this.contractRulesRecordStats.active = data.contractRulesData.filter((rule) => rule.status === true).length
				// this.contractRulesRecordStats.inactive = data.contractRulesData.filter((rule) => rule.status === false).length
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.contractRulesLocationLoading = false;
			})
	}

	onShowAll(){

	}

	shouldDisplayRule(rule) {
		if(rule.isNew === true || rule.isEdit === true) return true;
		if (this.filterByValue === 'all') {
		  return true;
		} else if (this.filterByValue === 'active') {
		  return rule.status === true;
		} else if (this.filterByValue === 'inactive') {
		  return rule.status === false;
		}
		return false;
	  };

	  updateContractStats(rules){
		this.contractRulesRecordStats.active = rules.filter((rule) => rule.status === true).length;
		this.contractRulesRecordStats.inactive = rules.filter((rule) => rule.status === false).length;
	  }

	  contractDatesChanged(isRule = false) {
		const { contractStartDate, contractEndDate } = this.model;
		
		setTimeout(() => {
			this.ruleStartDateOptions = {
				minDate: moment(contractStartDate),
				...(contractEndDate && { maxDate: moment(contractEndDate) }),
			};
		},100)
	
		this.showBillingWarning = this.billingRulesOptions.some((rule, index) => {
			const ruleStartDate = rule.startDate ? moment(rule.startDate) : null;
			const ruleEndDate = rule.endDate ? moment(rule.endDate) : null;
		
			const contractStart = moment(contractStartDate);
			const contractEnd = contractEndDate ? moment(contractEndDate) : null;

			const isInvalidStart = ruleStartDate && ruleStartDate.isValid() && !(
				ruleStartDate.isSameOrAfter(contractStart, "day") && 
				(contractEnd ? ruleStartDate.isSameOrBefore(contractEnd, "day") : true)
			);
	
			const isInvalidEnd = ruleEndDate && ruleEndDate.isValid() && !(
				ruleEndDate.isSameOrAfter(contractStart, "day") && 
				(contractEnd ? ruleEndDate.isSameOrBefore(contractEnd, "day") : true)
			);

			const isRuleInvalid = isInvalidStart || isInvalidEnd;

			return isRuleInvalid;
		});

		if(this.showBillingWarning && !isRule){
			this.billingRulesOptions.forEach((rule) => {
				rule.isEdit = false;
			})
		}
	}

	hasNonNewBillingRules() {
		return this.billingRulesOptions.some(rule => rule.isNew === true);
	};

	loadServiceTypeOptionChoice(selectedBillingEvent, serviceType, index) {
		this.isDisableServiceTypeOptions[index] = { disabled: false };
		if (!selectedBillingEvent) return;

		if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
			this.isDisableServiceTypeOptions[index].disabled = false;
			return [this.serviceTypeOptions['other'][0], ...this.serviceTypeOptions['regular'], ...this.serviceTypeOptions['flm'], ...this.serviceTypeOptions['slm']];
		}
		else if (['stop-completed', 'atm-cash-delivery', 'coin-pickup', 'coin-delivery', 'shipment-delivery-cant', 'shipment-pickup',
			'shipment-delivered', 'atm-cash-pickup', 'atm-deposit-pickup'].indexOf(selectedBillingEvent) > -1) {
			this.isDisableServiceTypeOptions[index].disabled = false;
			return this.serviceTypeOptions['other'];
		}
		else if (['atm-load-service', 'atm-load-cant'].indexOf(selectedBillingEvent) > -1) {
			this.isDisableServiceTypeOptions[index].disabled = false;
			return this.serviceTypeOptions['atmLoad'];
		}
		else {
			if (['deposit-count', 'atm-order-pack', 'pickup-deposit', 'atm-residual-deposit',
				'delivery-order-pack', 'atm-residual-count', 'atm-deposit-count'].indexOf(selectedBillingEvent) > -1) {

				if (serviceType && serviceType.toUpperCase() !== 'NONE') {
					this.isDisableServiceTypeOptions[index].disabled = false;
				}
				else {
					this.isDisableServiceTypeOptions[index].disabled = true;
				}
			}
			return this.serviceTypeOptions['none'];
		}
	};
}

export default ContractEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/edit/contract.edit.controller.js